import Screenfull from '@/components/Screenfull/index.vue'

const publicComponents = {
	Screenfull:Screenfull,
}

export default publicComponents